import { ArrowUpRight } from "lucide-react";

const posts = [
  {
    tag: "Market Report",
    date: "Nov 2025",
    title: "The 2026 Basmati outlook: yields, prices, and buyer strategy",
    img: "https://images.pexels.com/photos/7891849/pexels-photo-7891849.jpeg",
  },
  {
    tag: "Compliance",
    date: "Oct 2025",
    title: "New EU pesticide MRLs: what spice importers need to prepare for",
    img: "https://images.pexels.com/photos/36870366/pexels-photo-36870366.jpeg",
  },
  {
    tag: "Logistics",
    date: "Sep 2025",
    title: "Reefer capacity from Nhava Sheva: navigating the peak-season squeeze",
    img: "https://images.pexels.com/photos/262353/pexels-photo-262353.jpeg",
  },
];

export default function Insights() {
  return (
    <section id="insights" data-testid="insights-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 reveal">
          <div>
            <p className="overline">Insights</p>
            <h2 className="mt-4 font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#1A3626] leading-tight tracking-tight">
              Reports from the trade desk
            </h2>
          </div>
          <a href="#" className="btn-outline-dark text-sm !py-3 !px-6">
            View all insights <ArrowUpRight size={16} strokeWidth={1.5} />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <a
              key={i}
              href="#"
              className="group block reveal"
              data-testid={`insight-card-${i}`}
            >
              <div className="relative overflow-hidden h-64">
                <img
                  src={p.img}
                  alt={p.title}
                  className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-105"
                />
              </div>
              <div className="mt-6 flex items-center gap-4">
                <span className="overline text-[#C5A059]">{p.tag}</span>
                <span className="text-xs text-[#4B5563]">{p.date}</span>
              </div>
              <h3 className="mt-3 font-serif-display text-2xl text-[#1A3626] leading-snug group-hover:text-[#244A35] transition-colors">
                {p.title}
              </h3>
              <div className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-[#1A3626]">
                Read report
                <ArrowUpRight size={14} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
